// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_eh-3";
export var flatBottomCorners = "_eh-5";
export var productImage = "_eh-0";
export var quantityContainer = "_eh-2";
export var quantityHeader = "_eh-6";
export var tooltip = "_eh-1";
export var wrapAndEllipsesOverflow = "_eh-4";